import { render, staticRenderFns } from "./KategoriBarang.vue?vue&type=template&id=399ca546"
import script from "./KategoriBarang.vue?vue&type=script&lang=js"
export * from "./KategoriBarang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports